export const DateFormat = {
  ISO: 'YYYY-MM-DD',
  EUR: 'DD.MM.YYYY',
  EUR_DATE_TIME: 'DD.MM.YYYY HH:mm:ss',
  BIG_ENDIAN: 'YYMMDD',
  DDMMYY: 'DDMMYY',
} as const;
